import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

type State = {
	dialogOpen: boolean;
	errorMessage: string;
	isLoading: boolean;
	dialogOnDismiss: (() => void) | null;
};

type Actions = {
	setDialogOpen: (open: boolean) => void;
	setErrorMessage: (message: string) => void;
	openDialogWithError: (message: string, options?: { onDismiss?: () => void }) => void;
	closeDialog: () => void;
	setIsLoading: (isLoading: boolean) => void;
};

const useGlobalUXStore = create<State & Actions>((set, get) => ({
	dialogOpen: false,
	errorMessage: '',
	dialogOnDismiss: null,
	setDialogOpen: (dialogOpen) => set({ dialogOpen }),
	setErrorMessage: (errorMessage) => set({ errorMessage }),
	openDialogWithError: (errorMessage, options) => {
		set({ errorMessage, dialogOpen: true, dialogOnDismiss: options?.onDismiss ?? null });
	},
	closeDialog: () => {
		const onDismiss = get().dialogOnDismiss;
		onDismiss?.();
		set({ dialogOpen: false, dialogOnDismiss: null });
	},
	isLoading: false,
	setIsLoading: (isLoading) => set({ isLoading }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('globalUXStore', useGlobalUXStore);
}

export default useGlobalUXStore;
